import { render } from "./CanvasDragtarget.vue?vue&type=template&id=b0777fe4&lang=html"
import script from "./CanvasDragtarget.vue?vue&type=script&lang=js"
export * from "./CanvasDragtarget.vue?vue&type=script&lang=js"

import "./CanvasDragtarget.vue?vue&type=style&index=0&id=b0777fe4&lang=css"

import exportComponent from "/Users/benjamin/Sites/hyper-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__